import { makeStyles } from 'tss-react/mui';
import { colors, spacing, statusColorsInterflora } from '../../../styles/jss/variables';
import { link } from '../../../styles/jss/utils';
const useStyles = makeStyles()((theme) => ({
    editableContainer: {
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    editable: Object.assign(Object.assign({ minHeight: '218px', border: `1px solid ${colors.grey.grey7}`, background: colors.background.LIGHT_GREY }, theme.typography.small_regular), { padding: `${spacing.large} ${spacing.xs} 20px`, color: colors.grey.grey7, outline: 'none', width: '100%', '&:focus': {
            boxShadow: '0px 0px 8px #008be9, 0px 4px 8px rgba(0, 0, 0, 0.32)',
        }, '& input': {
            color: statusColorsInterflora.error.base,
            display: 'inline-block',
            border: 'none',
            outline: 'none',
            fontSize: 'inherit',
            fontStyle: 'italic',
            padding: 0,
        }, '&:hover': {
            boxShadow: theme.isFlyingFlowers ? '0px 4px 8px rgba(60, 60, 59, 0.32)' : '0px 4px 8px rgba(0, 0, 0, 0.32)',
            backgroundColor: colors.background.WHITE,
        }, '&:active': {
            backgroundColor: colors.background.WHITE,
        }, '&:focus-within': {
            boxShadow: '0px 0px 8px #008BE9, 0px 4px 8px rgba(0, 0, 0, 0.32)',
            backgroundColor: colors.background.WHITE,
        } }),
    editableFocus: {
        boxShadow: '0 0 8px rgba(0, 123, 255, 0.5)',
    },
    editableLabel: Object.assign({ position: 'absolute', top: spacing.xs, left: spacing.xs, transition: 'all 0.2s ease-in-out', pointerEvents: 'none' }, theme.typography.small_bold),
    placeholder: Object.assign(Object.assign({ position: 'absolute', top: '36px', left: spacing.xs }, theme.typography.small_regular), { color: colors.grey.grey6, pointerEvents: 'none' }),
    messageBoxCharCount: Object.assign(Object.assign(Object.assign({}, theme.typography.xxs_regular), theme.typographySpacing.xxs_regular_sm), { position: 'absolute', marginLeft: spacing.small, bottom: '1px', right: '10px' }),
    errorMessage: {
        color: theme.statusColors.error.base,
    },
    error: {
        border: `2px solid ${theme.statusColors.error.base}`,
        backgroundColor: colors.supplementary.white,
        marginBottom: spacing.xs,
        padding: `calc(${spacing.xs} - 1px)`,
    },
    personalisedMessageRecipient: { maxWidth: '9ch' },
    personalisedMessageSender: { maxWidth: '13ch' },
    askSuggestion: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    suggestionMessageButton: Object.assign(Object.assign(Object.assign(Object.assign({}, theme.typography.small_regular), theme.typographySpacing.small_regular_sm), link(colors.primary.gold4)), { color: colors.primary.gold5, marginTop: spacing.xs, display: 'flex', justifyContent: 'end center' }),
}));
export default useStyles;
